var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 3.667a.667.667 0 00-.667.666V7a.667.667 0 001.333 0V4.333A.667.667 0 007 3.667zm.613 5.746a.507.507 0 00-.06-.12l-.08-.1a.667.667 0 00-.727-.14.767.767 0 00-.22.14.667.667 0 00-.14.727.601.601 0 00.36.36.626.626 0 00.507 0 .6.6 0 00.36-.36.667.667 0 00.053-.253.907.907 0 000-.134.427.427 0 00-.053-.12zM6.999.333a6.667 6.667 0 100 13.334A6.667 6.667 0 007 .333zm0 12A5.334 5.334 0 117 1.666a5.334 5.334 0 010 10.667z"
  })));
}
export default SvgWarningOutlined;